/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccessRequestsAppAccessRulePostRequest
 */
export interface AccessRequestsAppAccessRulePostRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessRequestsAppAccessRulePostRequest
     */
    app_external_connection_id: string;
    /**
     * Person ID
     * @type {string}
     * @memberof AccessRequestsAppAccessRulePostRequest
     */
    person_id?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestsAppAccessRulePostRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestsAppAccessRulePostRequest
     */
    app_url?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestsAppAccessRulePostRequest
     */
    identifier_from_source: string;
}

/**
 * Check if a given object implements the AccessRequestsAppAccessRulePostRequest interface.
 */
export function instanceOfAccessRequestsAppAccessRulePostRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "app_external_connection_id" in value;
    isInstance = isInstance && "identifier_from_source" in value;

    return isInstance;
}

export function AccessRequestsAppAccessRulePostRequestFromJSON(json: any): AccessRequestsAppAccessRulePostRequest {
    return AccessRequestsAppAccessRulePostRequestFromJSONTyped(json, false);
}

export function AccessRequestsAppAccessRulePostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessRequestsAppAccessRulePostRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'app_external_connection_id': json['app_external_connection_id'],
        'person_id': !exists(json, 'person_id') ? undefined : json['person_id'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'app_url': !exists(json, 'app_url') ? undefined : json['app_url'],
        'identifier_from_source': json['identifier_from_source'],
    };
}

export function AccessRequestsAppAccessRulePostRequestToJSON(value?: AccessRequestsAppAccessRulePostRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'app_external_connection_id': value.app_external_connection_id,
        'person_id': value.person_id,
        'description': value.description,
        'app_url': value.app_url,
        'identifier_from_source': value.identifier_from_source,
    };
}

